var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","icon":"","color":"white"},on:{"click":function($event){return _vm.gotToSyncView()}}},[_c('v-icon',[_vm._v("mdi-cloud-refresh")]),_vm._v(" "+_vm._s(_vm.nbItemsToSync)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }